<template>
  <div style="height: 100%;padding-top: 10px;">
    <el-select v-model="year" placeholder="切换年份" size="small" @change="setYear">
      <el-option
        :label="y"
        :value="y"
        v-for="(y, i) in yearList"
        :key="i"
      ></el-option>
    </el-select>
    <sch_jysheet v-if="type == 'jyqkb'" />
    <sch_flsheet v-if="type == 'jyflb'" />
    <sch_tjsheet v-if="type == 'jytjb'"></sch_tjsheet>
  </div>
</template>
<script>
import sch_jysheet from "@/views/pages/sch_jysheet.vue";
import sch_flsheet from "@/views/pages/sch_flsheet.vue";
import sch_tjsheet from "@/views/pages/sch_tjsheet.vue";

export default {
  components: {sch_flsheet, sch_jysheet, sch_tjsheet},
  data() {
    return {
      yearList: [],
      year: new Date().getFullYear(),
      type: '',
    }
  },
  mounted() {
    this.type = this.$route.params.type;
    let yearList = [];
    for (let i = new Date().getFullYear(); i >= 2021; i--) {
      yearList.push(i);
    }
    this.yearList = yearList;
    if (sessionStorage.getItem("year")) {
      this.year = sessionStorage.getItem("year");
    }
  },
  methods: {
    setYear() {
      sessionStorage.setItem("year", this.year);
      window.location.reload();
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.type = to.params.type;
    next()
  },
}
</script>
<style>
html{overflow: hidden;}
</style>